import InputValidationAccessibilityFr from './fr';
import InputValidationAccessibilityEn from './en';

const InputValidationAccessibilityLang = {
    fr: { ...InputValidationAccessibilityFr },
    en: { ...InputValidationAccessibilityEn },
};

export default InputValidationAccessibilityLang;
